<template>
  <div>
    <top-bar heading="Analytics"></top-bar>
    <div class="container-fluid mt-3">
      <b-card class="h-100 p-1">
        <b-embed src="https://flooringtechnology.matomo.cloud/index.php?module=Widgetize&action=iframe&moduleToWidgetize=Dashboard&actionToWidgetize=index&idSite=1&period=week&date=today&token_auth=6683c62b9fba80d85d758691aa830ec3" type="iframe"></b-embed>
      </b-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Analytics',
  data () {
    return {};
  },
  methods: {},
  mounted () {},
  metaInfo: {
    title: 'Analytics'
  }
};
</script>
